import {
  ACTION_HINTS_PERSISTENCE,
  ACTION_HINTS_SLICES,
  MAINTENANCE_PERSISTENCE,
  MAINTENANCE_SLICES,
  WINDOWS_PERSISTENCE,
  WINDOWS_SLICES,
  bindPersistenceEntries,
  qualifySlices,
  validatePersistenceRegistry,
  type BoundPersistenceEntry,
  type SliceDeclaration,
} from '@krp/client-runtime'

import type { RootState } from '../app/rootReducer'
import { THEME_PERSISTENCE, THEME_SLICES } from '../app/theme'
import { aqsiModule, duplicatesModule, oneCModule, ownModule, platformModule, receiptsModule, scheduleModule, syncModule } from './modules'

/**
 * Реестр хранения приложения (D-070, R10): allowlist записей всех пакетов и
 * объявления сроков жизни всех слайсов. Кэш запросов и сессия — `screen`:
 * ответы сервера и состояние входа в браузере не сохраняются.
 */
export const SLICE_DECLARATIONS: readonly SliceDeclaration[] = [
  { name: 'shell.api', lifetime: 'screen', reason: 'кэш RTK Query: данные сервера перечитываются, не сохраняются' },
  { name: 'shell.session', lifetime: 'screen', reason: 'состояние входа спрашивается у Gateway после F5' },
  { name: 'shell.live', lifetime: 'screen', reason: 'состояние живого канала: после F5 канал подключается заново' },
  { name: 'shell.connection', lifetime: 'screen', reason: 'связь с сервером: после F5 проверяется заново первым же запросом' },
  // RP-MNT: режим обновления РМК — на устройстве (device), чтобы перезагрузка во время перезапуска сервера не выглядела аварией.
  ...qualifySlices('shell', MAINTENANCE_SLICES),
  ...qualifySlices('shell', WINDOWS_SLICES),
  ...qualifySlices('shell', ACTION_HINTS_SLICES),
  ...qualifySlices(platformModule.id, platformModule.slices),
  ...qualifySlices(oneCModule.id, oneCModule.slices),
  ...qualifySlices(aqsiModule.id, aqsiModule.slices),
  ...qualifySlices(ownModule.id, ownModule.slices),
  ...qualifySlices(receiptsModule.id, receiptsModule.slices),
  ...qualifySlices(duplicatesModule.id, duplicatesModule.slices),
  ...qualifySlices(syncModule.id, syncModule.slices),
  ...qualifySlices(scheduleModule.id, scheduleModule.slices),
  // UI-STYLE: тема оформления — выбор человека за устройством.
  ...qualifySlices('shell', THEME_SLICES),
]

export const PERSISTENCE_ENTRIES: readonly BoundPersistenceEntry<RootState>[] = [
  ...bindPersistenceEntries('shell', (state: RootState) => state.maintenance, MAINTENANCE_PERSISTENCE),
  ...bindPersistenceEntries('shell', (state: RootState) => state.windows, WINDOWS_PERSISTENCE),
  ...bindPersistenceEntries('shell', (state: RootState) => state.actionHints, ACTION_HINTS_PERSISTENCE),
  ...bindPersistenceEntries(platformModule.id, (state: RootState) => state.platform, platformModule.persistence),
  ...bindPersistenceEntries(oneCModule.id, (state: RootState) => state.onec, oneCModule.persistence),
  ...bindPersistenceEntries(aqsiModule.id, (state: RootState) => state.aqsi, aqsiModule.persistence),
  ...bindPersistenceEntries(ownModule.id, (state: RootState) => state.own, ownModule.persistence),
  ...bindPersistenceEntries(scheduleModule.id, (state: RootState) => state.schedule, scheduleModule.persistence),
  ...bindPersistenceEntries('shell', (state: RootState) => state.theme, THEME_PERSISTENCE),
]

validatePersistenceRegistry(PERSISTENCE_ENTRIES, SLICE_DECLARATIONS)
